import Model from "./Model";

export default class Franquia extends Model {
  constructor(franquia) {
    super();
    Object.assign(this, franquia);
  }
}
